import React, { useRef, useEffect } from "react"
import PropTypes from "prop-types"
import { parkingState } from "../../zustand/parkingState"

export default function OutsideClickTrigger({ children, modifier, onOutsideClick, modalOpenerId }) {
  const wrapperRef = useRef(null)
  const wrapperClass = "outside-click-trigger-wrapper" // Add a unique class for all instances

  useEffect(() => {
    let isContainerInitialized = false

    const handleOutsideClick = (event) => {
      if (event.type !== "keydown" && event.target.closest(`.${wrapperClass}`)) {
        return
      }

      if (parkingState && parkingState.getState().modalOpenerId) {
        const openerElement = document.getElementById(parkingState.getState().modalOpenerId)
        if (openerElement) {
          openerElement.focus()
        }
        onOutsideClick()
        return
      }

      if (modalOpenerId) {
        const openerElement = document.getElementById(modalOpenerId)
        if (openerElement) {
          openerElement.focus()
        }
        onOutsideClick()
        return
      }

      onOutsideClick()
    }

    const handleClickOutside = (event) => {
      if (!isContainerInitialized) {
        return
      }
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        handleOutsideClick(event)
      }
    }

    const handleFocusOutside = (event) => {
      if (!isContainerInitialized) {
        return
      }
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        handleOutsideClick(event)
      }
    }

    const handleEscapeKey = (event) => {
      if (!isContainerInitialized) {
        return
      }
      if (event.key === "Escape") {
        handleOutsideClick(event)
      }
    }

    document.addEventListener("keydown", handleEscapeKey)
    document.addEventListener("mousedown", handleClickOutside)
    document.addEventListener("focusin", handleFocusOutside) // Listen for focus changes

    const timer = setTimeout(() => {
      isContainerInitialized = true
    }, 50)

    return () => {
      document.removeEventListener("keydown", handleEscapeKey)
      document.removeEventListener("mousedown", handleClickOutside)
      document.removeEventListener("focusin", handleFocusOutside) // Clean up focus listener
    }
  }, [onOutsideClick, modalOpenerId])

  return (
    <div ref={wrapperRef} className={`${modifier} ${wrapperClass}`}>
      {children}
    </div>
  )
}

OutsideClickTrigger.propTypes = {
  children: PropTypes.element.isRequired,
  modifier: PropTypes.string,
  onOutsideClick: PropTypes.func.isRequired,
  modalOpenerId: PropTypes.string,
}
